import { gql, useQuery } from '@apollo/client';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

export const GET_GET_ALL_EMPLOYEES_FOR_LIST = gql`
  query getMembers($filter: FilterMemberInput) {
    getYuuHrMembers(filter: $filter) {
      collection {
        _id
        profile {
          displayName
          firstName
          lastName
        }
        healthInsurance {
          _id
          name
        }
        employeePersonalInfo {
          status
          employeeNumber
        }
      }
      totalCount
    }
  }
`;

export const useGetAllEmployeesForList = ({ filter }: { filter?: any } = {}) => {
  const currentCompanyId = useGetCurrentCompanyId();
  const { data, loading } = useQuery(GET_GET_ALL_EMPLOYEES_FOR_LIST, {
    variables: {
      filter: { companyId: currentCompanyId, ...filter },
    },
    skip: !currentCompanyId,
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getYuuHrMembers || {};

  return { loading, employees: collection, totalCount };
};
